import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { useHttpClient } from '@bonusly/http-client';

import { GranolaAuthorizeSchema, GranolaDisconnectSchema, GranolaStatusSchema } from '../schemas/granola';

const headers = {
	'Key-Inflection': 'camel',
};

const granolaKeys = {
	all: ['granola'] as const,
	status: () => [...granolaKeys.all, 'status'] as const,
};

const granolaPaths = {
	status: () => '/granola_mcp/status',
	authorize: () => '/granola_mcp/authorize',
	disconnect: () => '/granola_mcp/disconnect',
	meetings: () => '/granola_mcp/meetings',
};

export const useGranolaStatus = () => {
	const http = useHttpClient();
	return useQuery({
		queryKey: granolaKeys.status(),
		queryFn: async () => {
			const res = await http.get(granolaPaths.status(), { headers });
			return GranolaStatusSchema.parse(res.data);
		},
	});
};

export const useGranolaAuthorize = () => {
	const http = useHttpClient();
	return useMutation({
		mutationFn: async (returnPath?: string) => {
			const res = await http.get(granolaPaths.authorize(), {
				headers,
				params: returnPath ? { return_path: returnPath } : undefined,
			});
			return GranolaAuthorizeSchema.parse(res.data);
		},
	});
};

export const useGranolaMeetings = () => {
	const http = useHttpClient();
	return useMutation({
		mutationFn: async () => {
			const res = await http.get(granolaPaths.meetings(), { headers });
			return res.data as { meetings: unknown[] };
		},
	});
};

export const useGranolaDisconnect = () => {
	const http = useHttpClient();
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: async () => {
			const res = await http.delete(granolaPaths.disconnect(), { headers });
			return GranolaDisconnectSchema.parse(res.data);
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: granolaKeys.all });
		},
	});
};
